import Undo from '../../../../Assets/StorefrontIcons/Undo.svg';
import Redo from '../../../../Assets/StorefrontIcons/Redo.svg';
import { useDispatch, useSelector } from 'react-redux';
import { updateVersionIndex } from '../../../../Features/storefrontSlice';
import { showToast } from '../../../../Components/Toaster/Toaster';

function UndoRedoButtons() {
    const dispatch = useDispatch();

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    function handleUndo() {
        if(versionIndex > 0) {
            showToast(`Undo ${versionStack[versionIndex]?.comment}`, 'success');
            dispatch(updateVersionIndex(versionIndex - 1));
        }
        else {
            showToast('No edits to undo!', 'warning');
        }
    }

    function handleRedo() {
        if(versionIndex < versionStack.length - 1) {
            showToast(`Redo ${versionStack[versionIndex + 1]?.comment}`, 'success');
            dispatch(updateVersionIndex(versionIndex + 1));
        }
        else {
            showToast('No edits to redo!', 'warning');
        }
    }

    return (
        <div className="flex items-center">
            <div className='size-8 flex items-center justify-center'>
                <button onClick={handleUndo} className='size-[26px] flex items-center justify-center outline-none border-none rounded-full hover:bg-[#A6FFCB]'>
                    <img src={Undo} alt="" />
                </button>
            </div>

            <div className='size-8 flex items-center justify-center'>
                <button onClick={handleRedo} className='size-[26px] flex items-center justify-center outline-none border-none rounded-full hover:bg-[#A6FFCB]'>
                    <img src={Redo} alt="" />
                </button>
            </div>
        </div>
    );
}

export default UndoRedoButtons;
